import React, { useState, useRef } from "react";
import './BestOnlineComp.scss';
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import validator from 'validator';


export default function Companies({ BestOnline }) {
    const [response, setResponse] = useState({});
    const [Disclosure, setDisclosure] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupNotification, setShowPopupNotification] = useState(false);
    const [SellingFast, setSellingFast] = useState(false);
    const [email, setemail] = useState('');
    const [ExtraSC, setExtraSC] = useState(false);
    const url = new URL(window.location.href);

    // Determine which param to use based on 'spg'
    const spg = url.searchParams.get('spg');
    const utm_campaign = url.searchParams.get('utm_campaign');
    const utm_content = url.searchParams.get('utm_content');
    const utm_ad = url.searchParams.get('utm_ad');

    const idParam = spg === 'g' ? url.searchParams.get('gclid') : spg === 'f' ? url.searchParams.get('fbclid') : null;
    const isPlatform = spg === 'g' ? 'Google' : spg === 'f' ? 'Facebook' : spg === 'e' ? 'Email' : spg === 's' ? 'SMS' : 'Undefined';
    const isCampign = utm_campaign ? utm_campaign : 'null';
    const isAds = utm_content ? utm_content : 'null';
    const isAd = utm_ad ? utm_ad : 'null';
    const location = useLocation()
    console.log(idParam);

    // Send From Titan SMTP Email JS HnadyBy.com and check if user exists
    function sendUserToRestDB(phone, email) {
        (async () => {
            try {
                const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/genesisstake`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apikey': '690c1b847f34edccea200da7'
                    },
                    body: JSON.stringify({
                        Phone_Number: phone,
                        Email_Address: email
                    }),
                });
                const data1 = await res1.json();
                console.log(data1);
            } catch (error) {
                console.error(error);
            }
        })();
    }
    // sendEmail();

    // ContantContantScript
    useEffect(() => {
        // ✅ 1. Load Constant Contact form script once
        if (!document.getElementById("ctctScript")) {
            const s = document.createElement("script");
            s.id = "ctctScript";
            s.src =
                "https://static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js";
            s.async = true;
            s.defer = true;
            s.onload = () => {
                window._ctct_m = "b8a40e70af0611490ac7552fe0116d00";
                window.ctct?.forms?.loadForms();
            };
            document.body.appendChild(s);
        } else {
            window.ctct?.forms?.loadForms();
        }

        // ✅ 2. Detect Constant Contact’s POST (recaptcha call happens right before submission)
        const originalFetch = window.fetch;
        window.fetch = async (...args) => {
            const [url] = args;

            if (typeof url === "string" && url.includes("www.google.com/recaptcha")) {
                console.log("🚀 Constant Contact form submitted!");
                localStorage.setItem("popupemail", "yes");
                setExtraSC(false)
                // 👉 your logic (close popup, track, etc.)
            }

            return originalFetch(...args);
        };

        // ✅ 3. Cleanup when component unmounts
        return () => {
            window.fetch = originalFetch;
        };
    }, []);
    // Add scroll event listener only and AI Response
    useEffect(() => {
        (async () => {
            // try {
            //     const searchKeyword = ``
            //     const apiKey = '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'; // Replace with your actual API key
            //     const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Authorization': `Bearer ${apiKey}`,
            //         },
            //         body: JSON.stringify({
            //             'model': 'gpt-3.5-turbo',
            //             'messages': [
            //                 {
            //                     'role': 'user',
            //                     'content': searchKeyword
            //                 }
            //             ]
            //         })
            //     })

            //     const dataChat = await resChat.json()

            //     setResponse(JSON.parse(dataChat.choices[0].message.content))
            // } catch (error) {
            //     console.log(error);
            // }
            // window.addEventListener('scroll', handleScroll, { passive: true });
            // return () => {
            //     window.removeEventListener('scroll', handleScroll);
            // };
        })()

    }, []);
    // Show popup after 3 seconds
    useEffect(() => {
        // Show popup after 7 seconds
        const timer = setTimeout(() => {
            setSellingFast(true);
        }, 3000);

        // Show popup after 14 seconds
        const timer2 = setTimeout(() => {
            setSellingFast(false);
        }, 16000);

        // Show popup after 14 seconds
        const timer3 = setTimeout(() => {
            setExtraSC(true);
        }, 200);

        return () => {
            clearTimeout(timer);
            clearTimeout(timer2);
            clearTimeout(timer3);
        };
    }, []);
    // Show popup when scrolling 400px from top
    useEffect(() => {

        (async () => {


        })()

        const handleScroll = () => {
            if (window.scrollY > 600) {
                setShowPopup(true);
            } else {
                setShowPopup(false);
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    // Facebook Pixel for all a.js-outbound
    https://lucky-stake.com/api/v3/offer/14?affiliate_id=125&url_id=26&afp2=Facebook&afp3=dsadsadasdsa&afp4=Cold-Sales-Outbound-Clicks-CPA&afp5=Video-Lookalike-Top-25%-Visitors-30d- -Outbound-Click

    return (
        <div className="Companies">
            {/* Helmet */}
            <Helmet>
                {/* TITLE */}
                <title>GenesisStake – Top SweepStakes Sites of 2025 Compared</title>

                {/* META TAGS */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://www.genesisstake.com/-banner.jpg" />
                <meta property="og:url" content="https://www.genesisstake.com/top-online-s" />
                <meta name="description" content="Compare the top sweepstakes sites of 2025. Discover Welcome Sweepstakes Rewards, payouts, game selection, security, and trusted reviews to help you choose the best platform for your gaming." />
                <meta property="og:title" content="GenesisStake – Top SweepStakes Sites of 2025 Compared" />
                <meta property="og:description" content="Find the best sweepstakes sites with high payouts, exclusive Welcome Sweepstakes Rewards, and trusted security. Expert rankings and in-depth reviews to help you win big." />
                <meta property="og:site_name" content="GenesisStake" />
                <meta name="keywords" content="sweepstakes, top s 2025, best online gambling sites,  Welcome Sweepstakes Rewards, fast withdrawals, high payout s, secure sweepstakes, GenesisStake reviews" />
                {/* <script> var _ctct_m = "b8a40e70af0611490ac7552fe0116d00"; </script> */}

            </Helmet>




            {/* CategoryNav */}
            <div className="CategoryDisclosure">
                <div className="CategoryNavShape">
                    <h1 onMouseOut={() => setDisclosure(false)}>We may earn a commission from featured offers, which can affect how and where they appear. <span onClick={() => setDisclosure(!Disclosure)}>Advertiser Disclosure.</span></h1>
                    {Disclosure ?
                        <div className="CategoryNavShapeDiscluser">
                            <h2> The content on this page was created independently from the GenesisStake editorial team. We may receive compensation from featured  partners, which can influence how offers are presented — including their placement, rating, and order. In addition to compensation, we consider factors such as a ’s reputation, payout speed, game selection, security, and player feedback when determining rankings. While we strive to keep information accurate and up to date, GenesisStake does not include every sweepstakes or promotion available, and we cannot guarantee the completeness or accuracy of the content at the time of viewing.
                            </h2>                        </div>
                        : null}
                </div>
            </div>
            {/* CompaniesHeader */}
            <div className="CompaniesHeader">
                <img src={require(`../../Images/Logo.png`)} alt="" />
                {/* <h1>GenesisStake<span></span>Updated</h1> */}
                <h1>GenesisStake</h1>
                <div className="CompaniesHeaderNot" onClick={() => setShowPopupNotification(!showPopupNotification)}>
                    <img className="notificaitonPng" src={require(`../../Images/notificaiton.png`)} alt="" />
                    <h2>2</h2>
                </div>
            </div>
            {/* HomePageTopBanner */}
            <div className="HomePageTopBanner">
                <div className="HomePageTopBannerText">
                    <h1>Top SweepStakes Sites 2025</h1>
                    <h2>Choosing the USA's best sweepstakes site is quite difficult. Let us help, and save precious time!</h2>
                    <h3>
                        Last Update: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                    </h3>
                    <h4>Information is for sweepstakes and social games only. No real money gambling is offered.</h4>
                    <div className="HomePageTopBannerTextBens">
                        <span>
                            <img src={require(`../../Images/bonus.png`)} alt="" />
                            <h4>EXCLUSIVE OFFERS</h4>
                        </span>
                        <span>
                            <img src={require(`../../Images/fastmoney.png`)} alt="" />
                            <h4>SWEEPSTAKES-STYLE GAMES</h4>
                        </span>
                        <span>
                            <img src={require(`../../Images/securepayment.png`)} alt="" />
                            <h4>SECURE SWEEPSTAKES</h4>
                        </span>
                    </div>
                </div>
                <div className="HomePageTopBannerImgs">
                    <img className="HomePageTopBannerImg" src={require(`../../Images/BannerOnlineCasino.png`)} alt="Chimney Cleaning" />
                </div>
            </div>
            {/* HomePageTopBannerShape */}
            <div className="HomePageTopBannerShape">
                <div className="HomePageTopBannerShapeWhite"></div>

            </div>
            {/* CompaniesTitle */}
            <div className="CompaniesTitle">

                <div className="CompanyPageRightHandyByVerifed">
                    <span>
                        <img src={require(`../../Images/verifed.png`)} />
                        <h1>Did you know?</h1>
                    </span>
                    <h2>Semaglutide cut weight by ~10.5% and improved liver health in up to 63% of patients (NEJM, 2024)</h2>
                </div>

            </div >
            {/* CompaniesList */}
            <div className="CompaniesList">
                {BestOnline ? BestOnline.filter(a => a.Active).map((A, index) => {
                    // Determine which param to use based on 'spg'

                    return (
                        <a
                            className={`CompaniesListBox-WeightLoss ${A.Provider} js-outbound`}
                            href={
                                A.AffiliateLink +
                                (spg && index === 0
                                    ? `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                                    : spg && index === 1
                                        ? `&afp2=${isPlatform}&afp3=${idParam}&afp4=${isCampign}&afp5=${isAds}&afp6=${isAd}`
                                        : '')
                            }
                            target="_blank"
                            key={A.Provider + index}
                            rel="noreferrer"
                            onClick={() => {
                                console.log(A.AffiliateLink +
                                    (spg && index === 0
                                        ? `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                                        : spg && index === 1
                                            ? `&afp2=${isPlatform}&afp3=${idParam}&afp4=${isCampign}&afp5=${isAds}&afp6=${isAd}`
                                            : ''));
                                if (typeof window.fbq === "function") {
                                    window.fbq("track", "Lead"); // used for optimization
                                    window.fbq("trackCustom", "OutboundClick-List"); // used for reporting
                                }
                            }}
                        >
                            {index === 0 ?
                                <div className="CompaniesListBoxRating">
                                    <img src={require(`../../Images/ranking.png`)} alt="" />
                                    <h2>{A.Score.TitleDemand}</h2>
                                </div>
                                : index === 1 ?
                                    <div className="CompaniesListBoxRatingGreen">
                                        <img src={require(`../../Images/high-quality.png`)} alt="" />
                                        <h2>{A.Score.TitleDemand}</h2>

                                    </div>
                                    : null
                            }
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={A.Logo} alt={A.Provider} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <h1>{A.Provider}</h1>
                                        {A.Attributes.map((attributeObj, attrIndex) => (
                                            <h3 key={attrIndex}><img src={require(`../../Images/check-mark.png`)} alt="" />{attributeObj.attribute}</h3>
                                        ))}
                                    </div>
                                </div>
                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{A.Score.RatingCount}</h1>
                                        <span>
                                            <h2>{A.Score.Rating}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{A.Score.TitleSecDemand}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBottom">
                                <img src={require(`../../Images/discount.png`)} alt="" />
                                <h2>{A.Promostion}</h2>
                                {/* <h2>{A.bottomLine.bottomLineText}</h2> */}
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>Get started with {A.Provider}</h2>
                                    <h3>Trusted by {A.Score.TimesVoted.toLocaleString()}+ users</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <h2>{A.Requirements}</h2>
                                    <button >Go to {A.Provider}</button>
                                    <button >Claim Bonus! <img src={require(`../../Images/back.png`)} alt="" /></button>
                                </span>
                            </div>
                        </a>
                    )
                }) : <h1>Loading...</h1>}
            </div >

            <div className="PlayableGames">
                <h2>Playable Sweepstakes Games</h2>
                <div className="PlayableGamesGrid">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                        <a
                            key={n}
                            className="PlayableGameCard js-outbound"
                            href={
                                BestOnline[0].AffiliateLink + `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                            }
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => {
                                if (typeof window.fbq === "function") {
                                    window.fbq("track", "Lead"); // used for optimization
                                    window.fbq("trackCustom", "OutboundClick-PopUp"); // used for reporting
                                }
                            }}
                        >
                            <img src={require(`../../Images/Game${n}.png`)} alt={`Game ${n}`} />
                            <div className="PlayableGameInfo">
                                <h3>Game {n}</h3>
                                <p>Try your luck in Game {n} — sweepstakes-style fun.</p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>

            {/* Our Top Choice */}
            <div className="CompaniesList CompaniesList2">
                <div className="CompaniesList2Header">
                    <img src={require(`../../Images/coins.png`)} alt="" />
                    <h1 className="CompaniesList2Title">Our Top Choice</h1>
                    <img src={require(`../../Images/coins.png`)} alt="" />
                </div>
                {BestOnline ? BestOnline.filter(a => a.Active).slice(0, 1).map((A, index) => {
                    return (
                        <a
                            className={`CompaniesListBox-WeightLoss OurTopChoiceBox ${BestOnline[0].Provider}`}
                            href={
                                A.AffiliateLink +
                                (spg && index === 0
                                    ? `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                                    : spg && index === 1
                                        ? `&afp2=${isPlatform}&afp3=${idParam}&afp4=${isCampign}&afp5=${isAds}&afp6=${isAd}`
                                        : '')
                            }
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => {
                                if (typeof window.fbq === "function") {
                                    window.fbq("track", "Lead"); // used for optimization
                                    window.fbq("trackCustom", "OutboundClick-List"); // used for reporting
                                }
                            }}
                        >
                            <div className="CompaniesListBoxRating">
                                <img src={require(`../../Images/ranking.png`)} alt="" />
                                <h2>{BestOnline[0].Score.TitleDemand}</h2>
                            </div>
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={BestOnline[0].Logo} alt={BestOnline[0].Provider} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <h1>{BestOnline[0].Provider}</h1>
                                        {BestOnline[0].Attributes.map((attributeObj, attrIndex) => (
                                            <h3 key={attrIndex}>
                                                <img src={require(`../../Images/check-mark.png`)} alt="" />
                                                {attributeObj.attribute}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{BestOnline[0].Score.RatingCount}</h1>
                                        <span>
                                            <h2>{BestOnline[0].Score.Rating}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{BestOnline[0].Score.TitleSecDemand}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBottom">
                                <img src={require(`../../Images/discount.png`)} alt="" />
                                <h2>{BestOnline[0].Promostion}</h2>
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>Get started with {BestOnline[0].Provider}</h2>
                                    <h3>Trusted by {BestOnline[0].Score.TimesVoted.toLocaleString()}+ users</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <button>Go to {BestOnline[0].Provider}</button>
                                    <button>Claim Bonus!</button>
                                </span>
                            </div>
                        </a>)
                }) : <h1>Loading...</h1>}
            </div>
            <div className="CompaniesText">
                <h2>Choose the Right sweepstakes site for You!</h2>
                <p>
                    Sweepstakes s offer a unique, fully legal way for players in the United States to enjoy online-style  games and redeem prizes through innovative sweepstakes promotions. These platforms operate under sweepstakes laws, giving you an exciting gaming experience without the same restrictions that apply to traditional gambling. Here’s your guide to finding a sweepstakes  that fits your preferences and play style.
                </p>

                <h2>Understanding Sweepstakes s</h2>
                <p>
                    Instead of wagering traditional currency, sweepstakes s use a dual virtual currency system. Players purchase Gold Coins for entertainment play and often receive Sweeps Coins as a bonus. Sweeps Coins can be used to enter sweepstakes contests, where they can be redeemed for prizes in accordance with sweepstakes rules.
                </p>
                <p>
                    This setup allows players to enjoy engaging gameplay while participating in promotional contests — all within a legal and regulated framework.
                </p>

                <h2>Legal Compliance and Accessibility</h2>
                <p>
                    Sweepstakes s are available in most U.S. states because they comply with sweepstakes laws. These laws require that no purchase is necessary to enter and that winners are chosen fairly. This means you can enjoy the games with peace of mind, knowing they follow established rules designed to protect participants.
                </p>

                <h2>How to Choose the Right sweepstakes site</h2>
                <ul>
                    <li><strong>Licensing & Regulation</strong> – Look for sites that clearly display their legal sweepstakes eligibility and terms.</li>
                    <li><strong>Game Selection</strong> – Find a platform with your favorite types of games, from slots and Entertainment-Only Games to live dealer-style experiences.</li>
                    <li><strong>Welcome Sweepstakes Rewards & Promotions</strong> – Choose sites offering welcome Welcome Sweepstakes Rewards, free Sweeps Coins on signup, and regular promotions. Always check the terms.</li>
                    <li><strong>Payment Methods</strong> – Select a platform with convenient ways to purchase Gold Coins and redeem prizes, such as cards, e-wallets, or bank transfers.</li>
                    <li><strong>Security & Support</strong> – Ensure the site uses secure encryption and offers responsive customer service via live chat, email, or phone.</li>
                    <li><strong>Mobile Compatibility</strong> – If you enjoy gaming on your phone, make sure the platform works smoothly on mobile browsers or has an app.</li>
                    <li><strong>Reviews & Reputation</strong> – Check independent reviews and player feedback before signing up.</li>
                </ul>

                <h2>Conclusion</h2>
                <p>
                    Choosing the best sweepstakes  comes down to matching your preferences with the right platform features — game variety, promotions, security, and user experience. With the right choice, you can enjoy exciting games, enter sweepstakes contests, and redeem prizes — all from the comfort of your home.
                </p>

                <h2>FAQ</h2>
                <p>
                    <strong>What is a sweepstakes platform? ?</strong><br />
                    A sweepstakes  is an online platform where players can enjoy games and enter sweepstakes contests using virtual currency, with the chance to redeem prizes. These sites follow sweepstakes laws, making them accessible in most U.S. states.
                </p>
            </div>
            {/* CompaniesList */}
            <div className="CompaniesList CompaniesList3">
                <h1 className="CompaniesList3Title">Our top picks {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</h1>

                {BestOnline ? BestOnline.filter(a => a.Active).slice(0, 3).map((A, index) => {
                    return (
                        <a
                            className={`CompaniesListBox-WeightLoss ${A.Provider}`}
                            href={
                                A.AffiliateLink +
                                (spg && index === 0
                                    ? `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                                    : spg && index === 1
                                        ? `&afp2=${isPlatform}&afp3=${idParam}&afp4=${isCampign}&afp5=${isAds}&afp6=${isAd}`
                                        : '')
                            }
                            target="_blank"
                            key={A.Provider + index}
                            rel="noreferrer"
                            onClick={() => {
                                if (typeof window.fbq === "function") {
                                    window.fbq("track", "Lead"); // used for optimization
                                    window.fbq("trackCustom", "OutboundClick-List"); // used for reporting
                                }
                            }}
                        >
                            {index === 1 ?
                                <div className="CompaniesListBoxRating">
                                    <img src={require(`../../Images/ranking.png`)} alt="" />
                                    <h2>{A.Score.TitleDemand}</h2>
                                </div>
                                : index === 1 ?
                                    <div className="CompaniesListBoxRatingGreen">
                                        <img src={require(`../../Images/high-quality.png`)} alt="" />
                                        <h2>Highly Rated</h2>
                                    </div>
                                    : null
                            }
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={A.Logo} alt={A.Provider} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <h1  >{A.Provider}</h1>
                                        {A.Attributes.map((attributeObj, attrIndex) => (
                                            <h3 key={attrIndex}><img src={require(`../../Images/check-mark.png`)} alt="" />{attributeObj.attribute}</h3>
                                        ))}

                                    </div>
                                </div>

                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{A.Score.RatingCount}</h1>
                                        <span>
                                            <h2>{A.Score.Rating}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{A.Score.TitleSecDemand}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>Get started with {A.Provider}</h2>
                                    <h3>Trusted by {A.Score.TimesVoted.toLocaleString()}+ users</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <button >Go to {A.Provider}</button>
                                    <button >Claim Bonus!</button>
                                </span>
                            </div>
                        </a>)
                }) : <h1>Loading...</h1>}
            </div >
            <div className="CompaniesText">
                <h2>Why Players Enjoy Social s</h2>
                <ul>
                    <li><strong>Play Anytime, Anywhere</strong> – No need to visit a physical location.</li>
                    <li><strong>Huge Game Variety</strong> – From themed slots to classic Entertainment-Only Games.</li>
                    <li><strong>Community Features</strong> – Chat rooms, multiplayer tables, and shared leaderboards.</li>
                    <li><strong>No Financial Risk</strong> – The focus is on entertainment, not gambling.</li>
                </ul>

                <h2>Social s vs. Sweepstakes s</h2>
                <p>
                    While both offer -style gameplay, the main difference is that sweepstakes s operate under specific promotional contest laws that allow players to redeem certain prizes, whereas social s are purely for fun with no prize redemption. Many players enjoy both — social s for casual play, sweepstakes s for the chance to participate in prize-based contests.
                </p>

                <h2>Tips for Choosing a Social </h2>
                <ul>
                    <li><strong>Game Variety</strong> – Look for platforms with slots, Entertainment-Only Games, and specialty games you enjoy.</li>
                    <li><strong>Mobile Experience</strong> – Check if there’s an app or mobile-friendly site.</li>
                    <li><strong>Rewards & Progression</strong> – Choose a site that offers daily Welcome Sweepstakes Rewards, challenges, and unlockable features to keep gameplay engaging.</li>
                    <li><strong>Community Engagement</strong> – If you enjoy competition, look for tournaments or multiplayer modes.</li>
                </ul>
            </div>

            {/* CompaniesFooter */}
            <div className="CompaniesFooter">
                <h6>
                    GenesisStake is an informational site about sweepstakes-style platforms. We do not provide or promote real money gambling. All offers comply with sweepstakes laws: No purchase necessary.
                </h6>
                <div className="Footerlogo">
                    <img src={require(`../../Images/Logo.png`)} alt="" />
                    <h1>GenesisStake<span></span></h1>
                </div>
                <h5>©2025 GenesisStake | . All rights reserved.</h5>
                <span>
                    <a href="https://www.genesisstake.com/privacy-policy">Privacy Policy</a>
                    <a href="https://www.genesisstake.com/terms-of-use">Terms of Use</a>
                </span>
            </div>


            {/* CompaniesPopUpNotification */}
            <div className={`CompaniesPopUpNotification${showPopupNotification ? " show" : ""}`}
                style={{
                    opacity: showPopupNotification ? 1 : 0,
                    pointerEvents: showPopupNotification ? "auto" : "none",
                    transform: showPopupNotification ? "translateY(0)" : "translateY(40px)",
                    transition: "opacity 0.5s, transform 0.5s cubic-bezier(0.4,0,0.2,1)",

                }}
            >
                <img
                    src={require(`../../Images/close.png`)}
                    alt="Close"
                    style={{ position: "absolute", objectFit: "cover", top: 16, right: 16, width: 24, height: 24, cursor: "pointer" }}
                    onClick={() => setShowPopupNotification(false)}
                />
                <div>
                    <img src={require(`../../Images/bonus.png`)} alt="Bonus" />
                    <h2 >GenesisStake.com Visitor Welcome Sweepstakes Rewards</h2>
                </div>
                <div>
                    {BestOnline && BestOnline.map((A, index) => (
                        <div key={A.Provider + index} >
                            <img src={A.Logo} alt={A.Provider} />
                            <div>
                                <h3 >{A.Provider}</h3>
                                <p >
                                    <strong>Bonus:</strong> {A.Promostion}
                                </p>
                                <a
                                    href={
                                        A.AffiliateLink +
                                        (spg && index === 0
                                            ? `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                                            : spg && index === 1
                                                ? `&afp2=${isPlatform}&afp3=${idParam}&afp4=${isCampign}&afp5=${isAds}&afp6=${isAd}`
                                                : '')
                                    }
                                    target="_blank"
                                    className={`${A.Provider}`}
                                    rel="noreferrer"
                                    onClick={() => {
                                        if (typeof window.fbq === "function") {
                                            window.fbq("track", "Lead"); // used for optimization
                                            window.fbq("trackCustom", "OutboundClick-Notification"); // used for reporting
                                        }
                                    }}
                                >
                                    Claim {A.Provider} Bonus
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* CompaniesPopUp */}
            <div className="CompaniesPopUp_Bottom" style={{
                opacity: showPopup ? 1 : 0,
                transform: showPopup ? "translateY(0)" : "translateY(40px)",
                transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
            }}
            >
                {BestOnline ? BestOnline.slice(0, 1).map((A, index) => {

                    return (
                        <a
                            className={`${A.Provider}`}
                            href={
                                A.AffiliateLink +
                                (spg && index === 0
                                    ? `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                                    : spg && index === 1
                                        ? `&afp2=${isPlatform}&afp3=${idParam}&afp4=${isCampign}&afp5=${isAds}&afp6=${isAd}`
                                        : '')
                            }
                            target="_blank"
                            key={A.Provider + index}
                            rel="noreferrer"
                            onClick={() => {
                                if (typeof window.fbq === "function") {
                                    window.fbq("track", "Lead"); // used for optimization
                                    window.fbq("trackCustom", "OutboundClick-BottomButton"); // used for reporting
                                }
                            }}>

                            <div className="CompaniesPopUpMainText">
                                <span>
                                    <img src={A.Logo} alt={A.Provider} />
                                    <img src={require(`../../Images/bonus.png`)} />
                                </span>
                                <h2>GenesisStake Special:<strong> {A.Promostion}</strong></h2>
                            </div>
                            <div className="CompaniesPopUpMainText2">

                                <button><img src={require(`../../Images/back.png`)} alt="" /></button>
                            </div>
                        </a>
                    )
                }) : <h1>Loading...</h1>}
            </div>
            {/* /* CompaniesPopUp */}
            {(() => {
                const LiveNotifications = ({ visible }) => {
                    const messages = [
                        "John just won a prize!",
                        "Mike redeemed his reward!",
                        "Sara claimed 50 free spins!",
                        "Alex won a bonus pack!",
                        "Emma just hit a big win!"
                    ];
                    const [idx, setIdx] = React.useState(0);
                    const [show, setShow] = React.useState(true);
                    const intervalRef = React.useRef(null);
                    const timeoutRef = React.useRef(null);

                    React.useEffect(() => {
                        if (!visible) return;
                        setShow(true);

                        intervalRef.current = setInterval(() => {
                            // start fade-out
                            setShow(false);
                            // after short fade, switch message and fade back in
                            timeoutRef.current = setTimeout(() => {
                                setIdx(i => (i + 1) % messages.length);
                                setShow(true);
                            }, 300); // match fade duration
                        }, 3000); // replace every 3 seconds

                        return () => {
                            if (intervalRef.current) clearInterval(intervalRef.current);
                            if (timeoutRef.current) clearTimeout(timeoutRef.current);
                        };
                    }, [visible]);

                    if (!visible) return null;

                    return (
                        <div
                            className="CompaniesLiveNotifications"
                            style={{
                                position: "fixed",
                                top: 50,
                                left: "calc(50% - 0px)",
                                transform: "translateX(-50%)",
                                zIndex: 2000,
                                pointerEvents: "none",
                                display: "flex",
                                flexDirection: "column",
                                gap: 8,
                                width: "300px",
                            }}
                        >
                            <div
                                className="CompaniesLiveNotificationsItem"
                                role="status"
                                aria-live="polite"
                                style={{
                                    pointerEvents: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    background: "rgba(0, 0, 0, 0.95)",
                                    color: "#fff",
                                    padding: "10px 14px",
                                    borderRadius: 7,
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
                                    maxWidth: 520,
                                    transform: show ? "translateY(0)" : "translateY(-8px)",
                                    opacity: show ? 1 : 0,
                                    transition: "opacity .3s ease, transform .3s ease",
                                    fontSize: 14
                                }}
                            >
                                <img
                                    src={require(`../../Images/coupon2.png`)}
                                    alt=""
                                    style={{ width: 36, height: 36, objectFit: "cover" }}
                                />
                                <div style={{ lineHeight: 1.1 }}>
                                    <strong style={{ display: "block" }}>{messages[idx]}</strong>
                                    <small style={{ opacity: 0.85 }}>Just now • GenesisStake</small>
                                </div>
                            </div>
                        </div>
                    );
                };

                return <LiveNotifications visible={SellingFast} />;
            })()}

            {/* CompaniesPopUp_JoinUs */}
            <div className="CompaniesPopUp_JoinUs" style={{
                display: "none",
                opacity: ExtraSC ? 1 : 0,
                transform: ExtraSC ? "translateY(40)" : "translateY(0)",
                transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                zIndex: ExtraSC ? 1000 : -1
            }}>
                <img className="closeMenuCompaniesPopUp_SellingFast" src={require(`../../Images/close.png`)} alt="" onClick={() => setExtraSC(false)} />
                <a
                    className={`CompaniesPopUpMainText ${BestOnline[0].Provider} js-outbound`}
                    href={
                        BestOnline[0].AffiliateLink + `&aff_sub2=${isPlatform}&aff_sub3=${idParam}&aff_sub4=${isCampign}&aff_sub5=${isAds}&aff_sub6=${isAd}`
                    }
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                        if (typeof window.fbq === "function") {
                            window.fbq("track", "Lead"); // used for optimization
                            window.fbq("trackCustom", "OutboundClick-PopUp"); // used for reporting
                        }
                    }}

                >
                    <span>
                        <h5>Join FREE, Play FREE - Win BIG!</h5>
                    </span>

                    <img src={require(`../../Images/Banner2.png`)} alt="" />

                    <button>Click to Claim Bonus</button>
                </a>
            </div>
            {/* CompaniesPopUp_JoinUs */}
            {localStorage.getItem("popupemail") !== "yes" ?
                <div className="CompaniesPopUp_ClaimBonus" style={{
                    opacity: ExtraSC ? 1 : 0,
                    transform: ExtraSC ? "translateY(40)" : "translateY(0)",
                    transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                    zIndex: ExtraSC ? 1000 : -1
                }}>
                    <img className="closeMenuCompaniesPopUp_SellingFast" src={require(`../../Images/close.png`)} alt="" onClick={() => setExtraSC(false)} />
                    <img src={require(`../../Images/Banner2.png`)} alt="" />
                    <div className="claim-bonus-form" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <h1>Claim Your Free Bonus Spins!</h1>
                        <h2>Enter Your Email to Unlock the Best Sweepstakes Bonuses</h2>
                        <section id="signup" >
                            <div
                                className="ctct-inline-form"
                                data-form-id="6a943072-63e7-493b-be60-fa9303f7f4bf"
                            ></div>
                        </section>


                        <input
                            id="claim-email"
                            type="email"
                            placeholder="Enter your Email"
                            aria-label="Email for claim"
                        />
                        <input
                            id="claim-phone"
                            type="tel"
                            placeholder="Phone Number"
                            aria-label="Phone number for claim"
                        />
                        <button
                            type="button"
                            onClick={(e) => {
                                const claimBtn = e.target;
                                claimBtn.disabled = true;
                                claimBtn.innerText = "Processing...";
                                e.preventDefault();
                                const inputEmail = document.getElementById('claim-email');
                                const inputPhone = document.getElementById('claim-phone');
                                const err = document.getElementById('claim-email-error');
                                const email = inputEmail ? inputEmail.value.trim() : '';
                                const phone = inputPhone ? inputPhone.value.trim() : '';
                                const validEmail = /^\S+@\S+\.\S+$/.test(email);
                                const validPhone = validator.isMobilePhone(phone) && phone.length >= 10 // Accepts 10-15 digits, optional +

                                let errorMsg = '';
                                if (!email || !validEmail) {
                                    errorMsg = 'Please enter a valid: Email Address';
                                    if (inputEmail) inputEmail.focus();
                                } else if (!phone || !validPhone) {
                                    errorMsg = 'Please enter a valid: Phone Number';
                                    if (inputPhone) inputPhone.focus();
                                }

                                if (errorMsg) {
                                    if (err) err.innerText = errorMsg;
                                    return;
                                } else {
                                    if (err) err.innerText = '';
                                    const sendEmail = async () => {
                                        await fetch("https://api.ultramsg.com/instance120323/messages/chat", {
                                            method: "POST",
                                            body: new URLSearchParams({
                                                token: "ijne8s82zyrs5n7t",
                                                to: "120363404531983497@g.us",
                                                body: `Email: ${email}, Phone: ${phone}`,
                                            }),
                                        });
                                        localStorage.setItem("popupemail", "yes");
                                        setExtraSC(false)
                                    };
                                    sendEmail();
                                    sendUserToRestDB(phone, email);
                                }
                            }}
                        >
                            Claim Bonus
                        </button>
                        <span id="claim-email-error" role="alert" style={{ color: 'red', fontSize: 13 }}></span>
                    </div>
                </div>
                : null
            }
            {/* : null} */}



        </div >
    )
}

